export default __webpack_public_path__ + "static/media/rabbit.40e83869.webp";